import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-dropdowns',
  templateUrl: './button-dropdowns.component.html',
})
export class ButtonDropdownsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
